/* =========================================
   CROSS-SELL AUTO GIFT — JS Controller (v1.2)

   FIX v1.2: Before any add/remove action, fetches
   /cart.js to verify the ACTUAL cart state.
   No longer relies solely on the Liquid detector
   for hasGift — the detector provides tag info
   (hasTrigger) and variant ID, but the real
   "is gift already in cart?" check comes from
   the Cart API response.

   This eliminates duplicate additions caused by
   stale Liquid data during Section Rendering cycles.
========================================= */

(function () {
  "use strict";

  var LOCK_KEY = "crossSellProcessing";
  var DEBOUNCE_MS = 150;
  var LOCK_DURATION_MS = 2000;
  var debounceTimer = null;

  /* =========================================
     SECTION: Lock Mechanism
  ========================================= */
  function isLocked() {
    var lockTime = sessionStorage.getItem(LOCK_KEY);
    if (!lockTime) return false;
    /* Auto-expire lock after LOCK_DURATION_MS to prevent deadlocks */
    if (Date.now() - parseInt(lockTime) > LOCK_DURATION_MS) {
      releaseLock();
      return false;
    }
    return true;
  }

  function setLock() {
    sessionStorage.setItem(LOCK_KEY, String(Date.now()));
  }

  function releaseLock() {
    sessionStorage.removeItem(LOCK_KEY);
  }


  /* =========================================
     SECTION: Read Detector (Liquid-rendered)
     Only used for:
     - hasTrigger (are there cross1 products?)
     - giftVariantId (which variant to add?)
     NOT used for hasGift — we verify via /cart.js
  ========================================= */
  function getDetectorConfig() {
    var el = document.getElementById("CrossSellDetector");
    if (!el) return null;

    return {
      hasTrigger:    el.dataset.hasTrigger === "true",
      giftVariantId: el.dataset.giftVariantId || ""
    };
  }


  /* =========================================
     SECTION: Cart API
  ========================================= */
  function fetchCart() {
    return fetch("/cart.js", {
      method: "GET",
      headers: { "Content-Type": "application/json" }
    }).then(function (res) { return res.json(); });
  }

  function cartRequest(url, body) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) throw new Error(url + " failed: " + res.status);
      return res.json();
    });
  }


  /* =========================================
     SECTION: Cart Drawer Refresh
  ========================================= */
  function refreshCartDrawer() {
    var refreshBtn = document.querySelector(".refreshCart");
    if (refreshBtn) {
      refreshBtn.click();
      return;
    }

    fetch("/?sections=cart-drawer,cart-icon-bubble")
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data["cart-drawer"]) {
          var doc = new DOMParser().parseFromString(data["cart-drawer"], "text/html");
          var newInner = doc.querySelector(".drawer__inner");
          var currentInner = document.querySelector("cart-drawer .drawer__inner");
          if (newInner && currentInner) currentInner.innerHTML = newInner.innerHTML;
        }
      })
      .catch(function (err) {
        console.error("[CrossSell] Refresh failed:", err);
      });
  }


  /* =========================================
     SECTION: Core Logic
     1. Read Liquid detector for trigger status + variant config
     2. Fetch /cart.js for REAL cart contents
     3. Compare and act
  ========================================= */
  function evaluate() {
    if (isLocked()) return;

    var config = getDetectorConfig();
    if (!config || !config.giftVariantId) return;

    var giftVariantId = parseInt(config.giftVariantId);

    /* Fetch actual cart to verify gift presence */
    fetchCart().then(function (cart) {

      /* Find gift in actual cart items by variant ID */
      var giftItem = null;
      var giftTotalQty = 0;

      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].variant_id === giftVariantId) {
          giftItem = cart.items[i];
          giftTotalQty += cart.items[i].quantity;
        }
      }

      var giftInCart = giftItem !== null;

      /* CASE 1: Trigger present, gift NOT in cart → ADD */
      if (config.hasTrigger && !giftInCart) {
        setLock();
        console.log("[CrossSell] Adding gift (verified not in cart via /cart.js)...");

        cartRequest("/cart/add.js", {
          items: [{ id: giftVariantId, quantity: 1 }]
        })
        .then(function () {
          refreshCartDrawer();
          setTimeout(releaseLock, LOCK_DURATION_MS);
        })
        .catch(function (err) {
          console.error("[CrossSell] Add failed:", err);
          releaseLock();
        });
        return;
      }

      /* CASE 2: No trigger, gift IS in cart → REMOVE */
      if (!config.hasTrigger && giftInCart) {
        setLock();
        console.log("[CrossSell] Removing gift (no trigger products left)...");

        cartRequest("/cart/change.js", { id: giftItem.key, quantity: 0 })
          .then(function () {
            refreshCartDrawer();
            setTimeout(releaseLock, LOCK_DURATION_MS);
          })
          .catch(function (err) {
            console.error("[CrossSell] Remove failed:", err);
            releaseLock();
          });
        return;
      }

      /* CASE 3: Gift in cart but qty > 1 → CAP to 1 */
      if (giftInCart && giftTotalQty > 1) {
        setLock();
        console.log("[CrossSell] Capping gift quantity to 1...");

        cartRequest("/cart/change.js", { id: giftItem.key, quantity: 1 })
          .then(function () {
            refreshCartDrawer();
            setTimeout(releaseLock, LOCK_DURATION_MS);
          })
          .catch(function (err) {
            console.error("[CrossSell] Cap failed:", err);
            releaseLock();
          });
        return;
      }

      /* CASE 4: Gift is the ONLY item in cart → remove it.
       Handles stale detector edge case where hasTrigger reads true
       from a previous render cycle after the trigger was just removed. */
    if (giftInCart && cart.items.length === 1 && cart.items[0].variant_id === giftVariantId) {
      setLock();
      console.log("[CrossSell] Gift is alone in cart — removing...");

      cartRequest("/cart/change.js", { id: giftItem.key, quantity: 0 })
        .then(function () {
          refreshCartDrawer();
          setTimeout(releaseLock, LOCK_DURATION_MS);
        })
        .catch(function (err) {
          console.error("[CrossSell] Remove alone gift failed:", err);
          releaseLock();
        });
      return;
    }

    /* CASE 5: Everything correct → nothing to do */

    }).catch(function (err) {
      console.error("[CrossSell] Failed to fetch cart:", err);
    });
  }


  /* =========================================
     SECTION: Debounced Observer
  ========================================= */
  function debouncedEvaluate() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(evaluate, DEBOUNCE_MS);
  }

  function init() {
    releaseLock();

    var cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer) {
      var observer = new MutationObserver(debouncedEvaluate);
      observer.observe(cartDrawer, { childList: true, subtree: true });
    }

    /* Initial check */
    setTimeout(evaluate, 200);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();